import { findAll, getParentOfSelectedTopic } from '../../../helpers/tree';
import ContentType from '../../../helpers/contentType';

export default {
  getterEnrollmentContext : state => state.context,
  getterSelectedTopic     : state => state.selectedTopic,
  getProgress             : (state, getters, rootState, rootGetters) => {
    const menuTopics = rootGetters['plataforma/content/getterMenuTopics'];

    const topics = findAll(menuTopics, (item) => {
      if (item.topicTypeId !== ContentType.FOLDER && item.topicTypeId !== ContentType.PAGE) {
        const itemParent = item.parentTopicId && getParentOfSelectedTopic(menuTopics, item);

        if (item.parentTopicId && itemParent.topicTypeId === ContentType.PAGE) {
          return itemParent.isRecordProgress;
        } else {
          return true;
        }
      }

      return false;
    });

    const viewedTopics = topics.filter((item) => item.viewed);

    const progress = (viewedTopics.length / topics.length) * 100;

    if (isNaN(progress)) {
      return 0;
    }

    return Math.round(progress);
  }
};
